"use client";

import React, { useState } from "react";
import type { FaqItem } from "@/types";

interface Props {
  title: string;
  faqs?: FaqItem[];
}

// Veelgestelde-vragen-accordion — gedeeld tussen categorie-, merk- en
// salepagina's (zie CategoryContentAccordion hiernaast voor dezelfde reden).
export default function CategoryFaqSection({ title, faqs }: Props) {
  const [open, setOpen] = useState<number | null>(null);
  if (!faqs || faqs.length === 0) return null;
  return (
    <div style={{ margin: "40px 0" }}>
      <h3 style={{ fontSize: "1.25rem", fontWeight: 800, letterSpacing: "0.04em", color: "#1a1a1a", marginBottom: "20px", textTransform: "uppercase" }}>
        VEELGESTELDE VRAGEN OVER {title.toUpperCase()}
      </h3>
      <div style={{ border: "1px solid #e5e5e5", borderRadius: "4px", overflow: "hidden" }}>
        {faqs.map((faq, i) => (
          <div key={i} style={{ borderBottom: i < faqs.length - 1 ? "1px solid #e5e5e5" : undefined }}>
            <button
              onClick={() => setOpen(open === i ? null : i)}
              style={{ width: "100%", textAlign: "left", padding: "14px 18px", background: "#fff", border: "none", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: 600, fontSize: "0.9rem", color: "#1a1a1a" }}
            >
              {faq.question}
              <span style={{ fontSize: "0.85rem", color: "#aaa", marginLeft: "12px", flexShrink: 0 }}>{open === i ? "▲" : "▼"}</span>
            </button>
            {open === i && (
              <div style={{ padding: "0 18px 14px", fontSize: "0.87rem", color: "#555", lineHeight: 1.65, textAlign: "justify" }}>
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
